import { useState } from 'react';
import { useTexts } from '../../contexts/TextsContext';
import classes from './internal.module.scss';

const SESSION_KEY = 'internal_unlocked';

const Internal = () => {
    const texts = useTexts();
    const [isUnlocked, setIsUnlocked] = useState(sessionStorage.getItem(SESSION_KEY) === 'true');
    const [input, setInput] = useState('');
    const [error, setError] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (input === window.config.internalPassword) {
            sessionStorage.setItem(SESSION_KEY, 'true');
            setIsUnlocked(true);
        } else {
            setError(true);
            setInput('');
        }
    };

    return (
        <div className={classes.Page}>
            {isUnlocked ? (
                <iframe
                    src={window.config.internalGeniallyUrl}
                    className={classes.Frame}
                    allowFullScreen
                />
            ) : (
                <div className={classes.Gate}>
                    <div className={classes.GateBox}>
                        <h1 className={classes.GateTitle}>{texts.internalPageTitle}</h1>
                        <form onSubmit={handleSubmit} className={classes.GateForm}>
                            <input
                                type="password"
                                value={input}
                                onChange={(e) => { setInput(e.target.value); setError(false); }}
                                placeholder={texts.internalPasswordPlaceholder}
                                aria-label={texts.internalPasswordPlaceholder}
                                className={`${classes.GateInput} ${error ? classes.GateInputError : ''}`}
                                autoFocus
                            />
                            {error && <p className={classes.GateError}>{texts.internalPasswordError}</p>}
                            <button type="submit" className={classes.GateButton}>{texts.internalLoginButton}</button>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Internal;
